const momentoClienteList = [
    {
       id: 'Q',
       descricao: 'Quente',
       ordem: 10,
    },
    {
        id: 'M',
        descricao: 'Morno',
        ordem: 20,
     },
     {
        id: 'F',
        descricao: 'Frio',
        ordem: 30,
     },
 ]
  
 export default momentoClienteList